const ASSETS = "https://customer-assets-lxgj4vgw.emergentagent.net/job_bfe700d0-21d9-440b-8802-01f590ef3e40/artifacts";
const ASSETS2 = "https://customer-assets-7cd3h4nn.emergentagent.net/job_benessere-vanzago/artifacts";

export const BRAND = {
  name: "Francesca Cicardi",
  title: "Massoterapista M.C.B.",
  city: "Vanzago (Milano)",
  address: "Via Monte Carso, 19 — 20010 Vanzago (MI)",
  phoneDisplay: "348 312 3462",
  phoneRaw: "+393483123462",
  whatsapp: "393483123462",
  email: "cicardi.francesca@gmail.com",
  hours: [
    { days: "Lunedì — Venerdì", time: "09:30 – 21:00" },
    { days: "Sabato", time: "Solo su appuntamento" },
    { days: "Domenica", time: "Chiuso" },
  ],
  legal: "Prestazione di lavoro autonomo ai sensi dell'art. 2222 del Codice Civile",
};

export const IMAGES = {
  hero: `${ASSETS}/ix7b1243_image.png`,
  studio: `${ASSETS2}/269047433093d919_image.png`,
  logo: `${ASSETS}/2fcsmfxh_image.png`,
};

export const whatsappLink = (message) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT = whatsappLink(
  "Buongiorno Francesca, ho visitato il suo sito e vorrei prenotare un trattamento di massoterapia. Potremmo sentirci?"
);

export const MARQUEE_ITEMS = [
  "Massoterapia Professionale",
  "Linfodrenaggio Metodo Vodder",
  "Trattamento Decontratturante",
  "Kinesio Taping Incluso",
  "Studio Riservato a Vanzago",
];

export const CHAPTERS = [
  {
    number: "01",
    title: "Approccio Clinico e Umano",
    text: "Ogni corpo racconta una storia fatta di postura, tensioni quotidiane e stress. Il mio lavoro unisce la precisione della massoterapia M.C.B. a un ascolto attento ed empatico della persona.",
  },
  {
    number: "02",
    title: "Qualifica ed Esperienza",
    text: "Massoterapista M.C.B. qualificata (Arte Ausiliaria delle Professioni Sanitarie). Specializzata in massoterapia terapeutica, sportiva e decontratturante per il sollievo dal dolore, il recupero funzionale e la salute muscolare.",
  },
  {
    number: "03",
    title: "Studio Privato a Vanzago",
    text: "Ricevo nel mio studio privato di Vanzago: un'oasi di quiete e pulizia dove trovare soluzioni concrete contro stress, contratture e dolori da postura scorretta o attività sportiva.",
  },
];

export const FORMAZIONE = [
  { year: "2025", title: "Personal Trainer", detail: "Attestato di qualifica — corso di formazione allenatore / personal trainer c/o Non Solo Fitness." },
  { year: "2023", title: "Graston Technique", detail: "Corso di formazione sull'uso degli strumenti I.A.S.T.M., attestato di partecipazione." },
  { year: "2022", title: "Tecniche Articolari Osteopatiche", detail: "Corso teorico-pratico di 40 ore — Centro Olistico Milanese, Milano." },
  { year: "2018–2020", title: "Abilitazione M.C.B. (Massaggiatore Capo Bagnino)", detail: "Abilitazione riconosciuta dal Ministero della Sanità — ECOLIFE S.r.l. Salute e Benessere, Milano. Tesi: «Il ruolo della massoterapia nella cura dei pazienti amputati»." },
  { year: "2019", title: "Office Chair Massage", detail: "Massaggio in ufficio per la riduzione dello stress di braccia, cervicale e schiena." },
  { year: "2018", title: "Massaggio Thailandese", detail: "Corso pratico di 30 ore — Associazione ARCI Centro Benessere, Milano." },
  { year: "2016", title: "Massaggio Sportivo", detail: "Corso pratico di 18 ore — ALEPH Scuola Formazione Massaggiatori, Varese." },
  { year: "2016", title: "Linfodrenaggio Manuale (metodo Vodder)", detail: "Corso teorico-pratico di 30 ore — Centro Olistico Milanese, Milano." },
  { year: "2015", title: "Tecniche del Massaggio Svedese", detail: "Corso teorico-pratico di 39 ore — Centro Olistico Milanese, Milano." },
];

export const TREATMENTS = [
  {
    id: "decontratturante",
    title: "Decontratturante e Miofasciale",
    duration: "60 min",
    price: "€ 60,00",
    image: "https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    short: "Scioglie le tensioni muscolari profonde e combatte la rigidità, lavorando sul tessuto connettivo miofasciale.",
    long: "Un trattamento mirato per sciogliere contratture profonde, rigidità vertebrali e tensioni muscolari croniche. Il lavoro sul tessuto miofasciale libera i movimenti e restituisce elasticità al corpo. Ideale per schiena, collo e spalle affaticati.",
    included: "Kinesio taping incluso, se necessario",
  },
  {
    id: "sportivo",
    title: "Massaggio Sportivo",
    duration: "60 min",
    price: "€ 60,00",
    image: `${ASSETS2}/dcf10222c952ea63_image.png`,
    short: "Trattamento pre e post-gara per ottimizzare la performance muscolare e accelerare il recupero.",
    long: "Pensato per chi pratica attività sportiva: preparatorio prima della prestazione o defaticante dopo l'allenamento. Accelera il recupero muscolare, riduce l'indolenzimento e aiuta a prevenire infortuni.",
    included: "Kinesio taping incluso, se necessario",
  },
  {
    id: "linfodrenante",
    title: "Linfodrenante Metodo Vodder",
    duration: "60 min",
    price: "€ 70,00",
    image: `${ASSETS2}/a0dc55d1bf0d2947_image.png`,
    short: "Manovre leggere e ritmiche per contrastare ritenzione idrica e migliorare la microcircolazione. Utile per il recupero post operatorio.",
    long: "Il metodo Vodder utilizza manovre dolci, leggere e ritmiche che stimolano il sistema linfatico. Contrasta ritenzione idrica e gonfiore, dona gambe leggere e favorisce un profondo effetto detossinante. Utile per il recupero post operatorio.",
    included: "Kinesio taping incluso, se necessario",
  },
  {
    id: "rigenerante",
    title: "Massaggio Rigenerante",
    duration: "90 min",
    price: "€ 80,00",
    image: `${ASSETS2}/7aa522fcbee8cbe0_image.png`,
    short: "Trattamento total body che rilassa e rivitalizza mente e corpo.",
    long: "Novanta minuti dedicati interamente a te: un massaggio total body che scioglie ogni tensione, rilassa profondamente la mente e rivitalizza il corpo. Per uscire dallo studio completamente rigenerati.",
    included: "Trattamento total body completo",
  },
  {
    id: "office",
    title: "Office Chair Massage",
    duration: "20 min",
    price: "€ 30,00",
    image: `${ASSETS2}/15f950328dbcde91_image.png`,
    short: "Massaggio rapido su sedia ergonomica per collo, spalle e schiena affaticati dal lavoro.",
    long: "Venti minuti di sollievo immediato su sedia ergonomica, pensati per chi lavora molte ore al computer. Allevia le tensioni di collo, spalle e zona lombare senza bisogno di spogliarsi: perfetto anche in pausa pranzo.",
    included: "Ideale per le pause lavoro",
  },
];

export const PRICES = [
  { name: "Massaggio Decontratturante / Sportivo / Benessere", duration: "60 min", price: "€ 60,00" },
  { name: "Linfodrenaggio Metodo Vodder", duration: "60 min", price: "€ 70,00" },
  { name: "Massaggio Rigenerante Total Body", duration: "90 min", price: "€ 80,00" },
  { name: "Office Chair Massage", duration: "20 min", price: "€ 30,00" },
];

export const WHY_POINTS = [
  {
    icon: "ClipboardCheck",
    title: "Approccio Clinico e Olistico",
    text: "Valutazione iniziale per adattare ogni massaggio alle reali necessità del tuo corpo: si tratta la causa della tensione, non solo il sintomo.",
  },
  {
    icon: "Sparkles",
    title: "Studio Riservato e Accogliente",
    text: "Un ambiente sanificato, rilassante e pensato per il tuo massimo comfort: un solo paziente alla volta, per la massima privacy.",
  },
  {
    icon: "MapPin",
    title: "Facile da Raggiungere",
    text: "Lo studio si trova a Vanzago, in Via Monte Carso 19: una zona comoda con parcheggio disponibile nelle immediate vicinanze.",
  },
];

export const RATINGS = [
  { platform: "Google", score: "5/5", count: "30 recensioni" },
  { platform: "Treatwell", score: "4,9/5", count: "12 recensioni" },
];

export const TESTIMONIALS = [
  {
    author: "Stefano Chiodini",
    source: "Google",
    text: "Purtroppo ci sono solo cinque stelle! Poche, a mio avviso, per la professionalità di Francesca.",
  },
  {
    author: "Massimo Sommaggio",
    source: "Google",
    text: "Francesca molto preparata e disponibile. Mette tanta passione nel suo lavoro. Sa molto ascoltare ed è sempre pronta a intervenire dove ho dolore. Consigliatissima!",
  },
  {
    author: "Sara Fossati",
    source: "Google",
    text: "Fantastica! Ho iniziato a farmi massaggiare da Francesca da un annetto e sono rinata. Quando si comincia non si può più farne a meno.",
  },
  {
    author: "Lucia Baldari",
    source: "Google",
    text: "In poche sedute mi ha risolto il dolore lombare!",
  },
  {
    author: "Cristina Patregnani",
    source: "Google",
    text: "Professionista eccellente, molto preparata e in costante ricerca e aggiornamento. Mi sono rivolta a lei anche durante tutta la gravidanza. Consigliatissima!",
  },
  {
    author: "Recensore verificato",
    source: "Treatwell",
    text: "Ottima esperienza. Una delle migliori nella professione!",
  },
];

export const NAV_LINKS = [
  { label: "Chi Sono", href: "#chi-sono" },
  { label: "Trattamenti", href: "#trattamenti" },
  { label: "Listino", href: "#listino" },
  { label: "Recensioni", href: "#recensioni" },
  { label: "Contatti", href: "#contatti" },
];
